import { render, staticRenderFns } from "./estrategia.vue?vue&type=template&id=1da0f977&scoped=true&"
import script from "./estrategia.vue?vue&type=script&lang=ts&"
export * from "./estrategia.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da0f977",
  null
  
)

export default component.exports